




























































































import Vue from "vue";
import Component from "vue-class-component";
import { ProgramPackTexts } from "../bookings/programPackTexts";
import { TodayLoader, TodayData } from "./todayData";
import ProgramPage from "../components/programs/ProgramPage.vue";
import WriteToProfessional from "../components/guidelines/WriteToProfessional.vue";
import GuidelineRow from "../components/guidelines/GuidelineRow.vue";
import { GuidelineApi } from "../components/guidelines/guidelineApi";
import GuidelineRecorder from "../components/guidelines/GuidelineRecorder.vue";
import TreatmentTakeRow from "../components/treatments/TreatmentTakeRow.vue";
import TreatmentRecorder from "../components/treatments/TreatmentRecorder.vue";
import CzCard from "../components/cz/CzCard.vue";
import CzTitle from "../components/cz/CzTitle.vue";
import CzRing from "../components/cz/CzRing.vue";
import CzSection from "../components/cz/CzSection.vue";
import CzPlanRow from "../components/cz/CzPlanRow.vue";
import CzLink from "../components/cz/CzLink.vue";

// The day in blocks (D41): appointments, the whole treatment, guidelines, questionnaires, the appointments still to book
// of each program and the next lesson of each course; what is done today in the header ring (D38). No week strip (D36).
@Component({
  components: { ProgramPage, WriteToProfessional, GuidelineRow, GuidelineRecorder, TreatmentTakeRow, TreatmentRecorder, CzCard, CzTitle, CzRing, CzSection, CzPlanRow, CzLink },
})
export default class TodayPage extends Vue {
  data: TodayData = TodayLoader.empty();
  loaded: boolean = false;
  busyId: number = 0;
  busySlot: string = "";
  get bookings(): any[] {
    return this.data.bookings.slice().sort((a: any, b: any) => this.time(a.dtStart).localeCompare(this.time(b.dtStart)));
  }

  get unscheduled(): any {
    return { slot: "", label: this.$t("No set time").toString(), items: this.data.treatmentUnscheduled };
  }

  get total(): number {
    return TodayLoader.count(this.data);
  }

  get done(): number {
    return TodayLoader.done(this.data);
  }

  get ringLabel(): string {
    return this.$t("{0} of {1} done today").toString().replace("{0}", String(this.done)).replace("{1}", String(this.total));
  }

  get dateLabel(): string {
    if (!this.data.today) return "";
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { weekday: "long", day: "numeric", month: "long" }).format(new Date(this.data.today + "T12:00:00"));
  }

  // Per program in progress, the next session still to book of each appointment card; a by-days program is booked whole.
  get programTasks(): any[] {
    const t = (key: string) => this.$t(key).toString();
    return this.data.programs
      .map((e: any) => {
        const cards = ProgramPackTexts.cards(e, 0);
        const pending = cards.reduce((n: number, k: any) => n + Math.max(0, Math.max(1, k.quantity) - k.bookings.length), 0);
        const byDays = e.layout === 0;
        return {
          id: e.id,
          name: e.name,
          bookWhole: byDays && pending > 0,
          pendingText: ProgramPackTexts.count(t, pending, "1 appointment", "{0} appointments"),
          rows: byDays ? [] : cards.reduce((all: any[], k: any) => all.concat(ProgramPackTexts.sessionRows(t, e, k)), []).filter((r: any) => r.action && !r.booked),
        };
      })
      .filter((p: any) => p.bookWhole || p.rows.length);
  }

  courseSub(c: any): string {
    const progress = this.$t("{0} of {1} lessons").toString().replace("{0}", String(c.completedLessons)).replace("{1}", String(c.lessonCount));
    return c.nextLesson ? this.$t("Next: {0}").toString().replace("{0}", c.nextLesson.title) + " · " + progress : progress;
  }

  link(row: any): string {
    return GuidelineApi.link(row, "/today");
  }

  origin(row: any): string {
    const program = this.data.programByGuideline[row.id];
    return program ? this.$t("Program {0}").toString().replace("{0}", program) : this.$t("From your professional").toString();
  }

  time(start: string): string {
    return (start || "").substring(11, 16);
  }

  toggle(row: any) {
    (this.$refs.recorder as any).toggle(row);
  }

  toggleTake(row: any) {
    (this.$refs.takes as any).toggle(row, this.data.treatmentDay);
  }

  async retryTreatment() {
    if (!(await TodayLoader.reloadTreatment(this.data))) this.data = await TodayLoader.load();
  }

  updateRow(row: any) {
    this.data.rows = this.data.rows.map((r) => (r.id === row.id ? row : r));
  }

  async mounted() {
    this.data = await TodayLoader.load();
    this.loaded = true;
    await this.$nextTick();
    this.scrollToSection();
  }

  scrollToSection() {
    const el = this.$route.hash && document.getElementById(this.$route.hash.slice(1));
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }
}
